import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseAPIService } from '../base.service';

@Injectable({
  providedIn: 'root'
})
export class ExameService extends BaseAPIService {

  constructor(protected http:HttpClient) { 
    super('exame/exame/');
  }

  previous(filter)
  { return this.send<any>('previous',  filter); }

  find(codigo)
  { return this.send<any>('find',  {Codigo: codigo}); }

  ObterResumo(filter)
  {
    return this.send<any>('obterresumo',  filter);
  }

  enviarLaudo(email, IdExame, salvarEmail)
  {
    return this.send<any>('enviarlaudo', {Email: email, IdExame: IdExame, SalvarEmail: salvarEmail});
  }

  alterarprioridade(exm) 
  {
    return this.send<any>('alterarprioridade', {IdExame: exm.IdExame}); 
  }

  obterPrioridades() 
  {
    return this.send<any>('obterprioridades', {}); 
  }

  download(IdExame)
  {
    return this.send<any>('download',  {IdExame:IdExame});
  }

  upload(IdExame:string, arquivos:any[])
  {
    return this.send<any>('upload',  {IdExame:IdExame, Arquivos:arquivos});
  }

}
